import { createRequestInstance } from '../'

const COMMERCE_URL = import.meta.env.VITE_COMMERCE_URL || ''
const SKU = 'CAP'

const request = createRequestInstance({
  baseURL: COMMERCE_URL,
})

export async function fetchCheckoutPortalURL() {
  const response = await request.get(`/stripe/session/checkout?sku_code=${SKU}`)
  return response.data.sessionUrl
}

export async function fetchBillingPortalURL() {
  const response = await request.get('/stripe/session/billing')
  return response.data.sessionUrl
}

type FetchCustomerResponse = {
  hasActiveSubscription: boolean
  subscriptionCancelDate: null | number
}

export async function fetchCustomer() {
  const response = await request.get<FetchCustomerResponse>(`/stripe/customer`)
  const { hasActiveSubscription, subscriptionCancelDate } = response.data

  return { hasActiveSubscription, subscriptionCancelDate }
}

type PricingResponse = {
  price: {
    currency: string //Ex: "usd"
    unitPrice: number //ex: 12500
  }
}

export async function fetchPricing() {
  const response = await request.get<PricingResponse>(
    `/skus/${SKU}?include_price=true`,
  )
  return response.data
}
